<script lang="ts">
	import { onMount } from "svelte";
	import { APIHelper } from "./code/APIHelper";
	import DBG from "./code/DBG";
	import Intercoms from "./code/Intercoms";
	import ProjectData from "./code/ProjectData";
	import ProjSettings from "./code/model/ProjSettings";

	import { Screens } from "./code/Screens";
	import type Task from "./code/Task";
	import Chart from "./components/Chart.svelte";
	import Loader from "./components/Loader.svelte";

	import Settings from "./components/Settings.svelte";

	import ProgressBar from "../public/lib/ProgressBar.cjs";
	import UnauthPage from "./components/UnauthPage.svelte";
	import LicenceExpired from "./components/LicenceExpired.svelte";
	import { Router, Route } from "svelte-routing";
	import AuthDone from "./components/AuthDone.svelte";
	import StartAuth from "./components/StartAuth.svelte";
	import SignOut from "./components/SignOut.svelte";
	import PostLogout from "./components/PostLogout.svelte";
	import AuthInfo from "./code/model/AuthInfo";
	import GlobalSettings from "./code/GlobalSettings";
	import AdminPage from "./components/AdminPage.svelte";
	import Identity from "./components/Identity/Identity.svelte";
	import Button from "./components/Generic/Button.svelte";

	export let name: string;
	/** Current URL */
	export let url: string = "";
	let screen: Screens = Screens.Loading;
	let eventsSubscribed: any[] = new Array();
	let appSettings: ProjSettings;
	let chartData: Task[];
	let progress: ProgressBar;
	let progressPercent: number;
	let userEmail: string = undefined;

	onMount(() => {
		DBG.log("App - onMount", name);
		// Starting point of Add-in

		Office.onReady((info) => {
			DBG.log("App - Office onReady called");
			if (info.host === Office.HostType.Project) {
				GlobalSettings.initFields();
				// Step #1 - get authenticated user from API

				APIHelper.getUserFromAPI()
					.then((u) => {
						DBG.log(
							"App - loadWhenAuthenticated - got user from API",
							u
						);
						let user = new AuthInfo(u);
						ProjectData.authUser = user;
						DBG.log(
							"App - License days till expiry",
							user.daysTillExpiry()
						);
						// Step #2 - if logged in, check licence
						if (user.daysTillExpiry() > 0) {
							// Step #3 - licence OK, start loading chart
							showLoading();
							getProjectGuidAndInitChart();
						} else {
							// Step #2b - licence expired/invalid - show UI
							screen = Screens.NoLicence;
						}
					})
					.catch((reason) => {
						// Step #1b - if not logged in, show UI
						DBG.log(
							"App - APIHelper.getUserFromAPI returned null - not logged in",
							reason
						);
						screen = Screens.NotAuth;
					});
			} else {
				DBG.log(
					"App - Office onReady called - not running under PROJECT"
				);
			}
		});
	});

	/*function loadWhenAuthenticated(user: AuthInfo) {
		DBG.log(
			"App - loadWhenAuthenticated, authInfo=",
			user
		);

		userEmail = user.rowKey;
		APIHelper.getUserFromAPI().then((user) => {
			DBG.log("App - loadWhenAuthenticated - got user from API", user);
			ProjectData.authUser = user;
			DBG.log("App - License days till expiry", user.daysTillExpiry());

			if (user.daysTillExpiry() > 0) {
				showLoading();
				getProjectGuidAndInitChart();
			} else {
				screen = Screens.NoLicence;
			}
		});
 
	}*/
	function onTaskSelectionChanged(eventArgs) {
		DBG.log("App - Event raised - onTaskSelectionChanged: ", eventArgs);

		//DBG.log("Last sel: " + Office.context.document.settings.get("lastSel"));
		//Office.context.document.settings.set("lastSel", new Date().toISOString());
		DBG.log("App -  onTaskSelectionChanged - set sel");

		Office.context.document.getSelectedViewAsync((result) => {
			DBG.log("App - OnReady = getSelectedViewAsync", result);
		});
		Office.context.document.getSelectedDataAsync(
			Office.CoercionType.Text,
			(result) => {
				DBG.log("App -  OnReady = getSelectedDataAsync", result);
			}
		);

		Office.context.document.getProjectFieldAsync(
			Office.ProjectProjectFields.GUID,
			(result) => {
				DBG.log("App - OnReady = GUID", result);
			}
		);

		// Task.ReadData(eventArgs);
	}
	function onViewChanged(eventArgs) {
		console.log("Event raised - onViewChanged: ", eventArgs);
	}

	function getProjectGuidAndInitChart() {
		Office.context.document.getProjectFieldAsync(
			Office.ProjectProjectFields.GUID,
			(result) => {
				DBG.log("App - getProjectGuidAndInitChart - result", result);
				if (result.status === Office.AsyncResultStatus.Succeeded) {
					let projectGuid: string = result.value.fieldValue;

					APIHelper.GetProjectSettings(projectGuid)
						.then((sets) => {
							DBG.log("App - Project settings:", sets);
							appSettings = sets;
							GlobalSettings.settings = appSettings;
							refreshChart();
						})
						.catch((reason) => {
							DBG.log("App - Project settings not found", reason);
							appSettings = new ProjSettings(projectGuid);

							appSettings.projectName =
								Office.context.document.url;
							GlobalSettings.settings = appSettings;
							screen = Screens.Settings;
						});
				}
			}
		);
	}

	Intercoms.listen(
		"settings.closed",
		(settings) => {
			DBG.log("App - listen - settings.closed", settings);
			//GlobalSettings.settings = settings;
			showLoading();
			ProjectData.ReadAllTasksInQueue((prog) => {
				DBG.log("App - progress " + prog);
				progressPercent = prog;
				progress.setWidthRatio(prog);
			}).then((cd) => {
				DBG.log("App - read chart data: ", cd);

				chartData = cd;
				progress.complete();
				screen = Screens.Chart;
			});
		},
		eventsSubscribed
	);

	function showLoading() {
		if (!progress) {
			progress = new ProgressBar({
				target: document.querySelector("main"),
				props: { color: "#031747" },
			});
		}
		progressPercent = 0;
		progress.setWidthRatio(0);
		screen = Screens.Loading;
	}

	function goToSettings() {
		screen = Screens.Settings;
	}
	function refreshChart() {
		//screen = Screens.Loading;
		progressPercent = 0;
		progress.setWidthRatio(0);
		ProjectData.ReadAllTasksInQueue((prog) => {
			DBG.log("App - progress " + prog);
			progressPercent = prog;
			progress.setWidthRatio(prog);
		}).then((cd) => {
			DBG.log("App - refresh - read chart data: ", cd);
			chartData = cd;
			progress.complete();
			setTimeout(() => {
				Intercoms.send("chart.refresh", chartData);
			}, 100);
			screen = Screens.Chart;
		});
	}
</script>

<main>
	<Router {url}>
		<Route path="/doneauth">
			<AuthDone />
		</Route>
		<Route path="/startauth">
			<StartAuth />
		</Route>
		<Route path="unauth">
			<UnauthPage />
		</Route>
		<Route path="/signout">
			<Identity page="logout" />
		</Route>
		<Route path="/postlogout">
			<PostLogout />
		</Route>
		<Route path="/register">
			<Identity page="register" />
		</Route>
		<Route path="/signin">
			<Identity page="login" />
		</Route>
		<Route path="/passreset">
			<Identity page="passreset" />
		</Route>

		<Route path="/settings">
			{#if appSettings}
				<Settings bind:projSetting={appSettings} />
			{:else}
				<Loader text="Loading..." {progressPercent} />
			{/if}
		</Route>
		<Route path="licexp">
			<LicenceExpired {userEmail} />
		</Route>
		<Route path="/admin">
			<AdminPage />
		</Route>
		<Route path="/map">MAP</Route>
		<Route path="/">
			{#if screen == Screens.Loading}
				<Loader text="Loading..." {progressPercent} />
			{:else if screen == Screens.Settings}
				<Settings bind:projSetting={appSettings} />
			{:else if screen == Screens.NotAuth}
				<UnauthPage />
			{:else if screen == Screens.NoLicence}
				<LicenceExpired {userEmail} />
			{:else if screen == Screens.Chart}
				<div
					class="app-chart-layout"
					class:wideChart={appSettings && appSettings.wideChart}
				>
					<p>Time-location chart</p>
					<Chart
						settings={appSettings}
						{chartData}
						wideChart={appSettings.wideChart}
						showChartLegend={appSettings.showChartLegend}
					/>
					<div class="chart-buttons">
						<Button
							Text="Settings"
							Icon="fa-cogs"
							on:click={goToSettings}
						/>

						<Button
							Text="Refresh"
							Icon="fas fa-sync"
							on:click={refreshChart}
						/>
					</div>
				</div>
			{/if}
		</Route>
	</Router>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		min-height: 100%;
		font-family: tlmsp;
	}

	.app-chart-layout {
		display: flex;
		flex-direction: column;
		width: 100%;
	}
	.wideChart {
		align-items: flex-start;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}

	.chart-buttons {
		display: flex;
		flex-direction: row;
		margin-top: 1rem;
		border-top: 1px solid gray;
		padding-top: 1rem;
	}
</style>
